class Event {
  queue: any;
  constructor() {
    this.queue = {};
  }

  $on(name: any, callback: any) {
    this.queue[name] = this.queue[name] || [];
    this.queue[name].push(callback);
  }

  $off(name: any, callback: any) {
    if (this.queue[name]) {
      for (let i = 0; i < this.queue[name].length; i++) {
        if (this.queue[name][i] === callback) {
          this.queue[name].splice(i, 1);
          break;
        }
      }
    }
  }

  $emit(name: any, data: any) {
    if (this.queue[name]) {
      this.queue[name].forEach(function (callback: any) {
        callback(data);
      });
    }
  }
}

export default new Event();
